// The fork at sign up: are you looking for work, or do you need cover?
//
// It is a real radio group, not two buttons with state. A screen reader hears
// one question with two answers, arrow keys move between them, and the browser
// handles the rest. The visible card is a styled <label>, which is why the input
// is sr-only rather than hidden: a hidden input is not focusable.
//
// The choice decides three things downstream: which welcome email arrives, which
// app store link is in it, and whether the next screen offers to carry on in the
// browser. So it is asked once, plainly, and never guessed.

const OPTIONS = [
  { value: 'work',  title: 'I’m looking for work',   body: 'Pick up shifts near you and get paid the day you work.' },
  { value: 'cover', title: 'I need cover',            body: 'Post shifts and fill them with checked professionals.' },
]

export default function AudienceChoice({ value, onChange, name = 'audience' }) {
  return (
    <fieldset className="border-0 p-0">
      <legend className="mb-3 text-[15px] font-semibold text-ink">What brings you here?</legend>
      <div className="grid gap-3 sm:grid-cols-2">
        {OPTIONS.map((o) => {
          const active = value === o.value
          return (
            <label
              key={o.value}
              // ⚠️ THE FOCUS RING DRAWS ON THE CARD, via peer-focus-visible.
              // The input is sr-only, which correctly keeps it focusable, but it
              // is a 1x1px box inside a 354x120 card: the global 2px ring
              // rendered as a ~9px square underneath the decorative circle, so
              // focused and unfocused were PIXEL IDENTICAL. Keyboard users had
              // no way to tell where they were on the page that converts.
              className={`audience-option cursor-pointer rounded-[16px] border p-5 transition-colors ${
                active
                  ? 'border-action bg-action-tint'
                  : 'border-hairline bg-surface hover:border-ink/25'
              }`}
            >
              <input
                type="radio"
                name={name}
                value={o.value}
                checked={active}
                onChange={() => onChange(o.value)}
                className="peer sr-only"
              />
              <span className="flex items-start gap-3">
                <span
                  aria-hidden="true"
                  className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
                    active ? 'border-action' : 'border-ink/25'
                  }`}
                >
                  {active && <span className="h-2.5 w-2.5 rounded-full bg-action" />}
                </span>
                <span>
                  <span className="block text-[17px] font-semibold text-ink">{o.title}</span>
                  <span className="mt-1 block text-[15px] leading-relaxed text-ink/80">{o.body}</span>
                </span>
              </span>
            </label>
          )
        })}
      </div>
    </fieldset>
  )
}
